import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import axios from 'axios'
import dayjs from 'dayjs'

import HOSTNAME from 'index'

import AlertDialog from 'components/AlertDialog'
import AppBarTop from '../components/AppBarTop'
import Copyright from '../components/Copyright'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import Skeleton from '@mui/material/Skeleton'
import TextField from '@mui/material/TextField'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { makeStyles } from '@mui/styles'
import InputMask from 'react-input-mask'

const useStyles = makeStyles({
    fixTop: {
        marginTop: '8px!important',
    }
})

const Main = () => {
    const classes = useStyles()
    const history = useHistory()

    const
        [session, setSession] = useState(0),
        [firstName, setFirstName] = useState(''),
        [lastName, setLastName] = useState(''),
        [phone, setPhone] = useState(''),
        [address, setAddress] = useState(''),
        [city, setCity] = useState(''),
        [state, setState] = useState('NY'),
        [zip, setZip] = useState(''),
        [email, setEmail] = useState(''),
        [emailConfirm, setEmailConfirm] = useState(''),
        [sessions, setSessions] = useState(null),
        [disableSubmit, setDisableSubmit] = useState(false),
        [loading, setLoading] = useState(false),
        [dialogDisplay, setDialogDisplay] = useState(false),
        [dialogMessage, setDialogMessage] = useState('')

    const dialog = (message) => {
        setDialogDisplay(true)
        setDialogMessage(message)
    }

    const setSubmit = (val = true) => {
        setDisableSubmit(val)
        setLoading(val)
    }

    const handleSessionChange = (e) => {
        setSession(e.target.value)
    }

    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value)
    }

    const handleLastNameChange = (e) => {
        setLastName(e.target.value)
    }

    const handlePhoneChange = (e) => {
        setPhone(e.target.value)
    }

    const handleAddressChange = (e) => {
        setAddress(e.target.value)
    }

    const handleCityChange = (e) => {
        setCity(e.target.value)
    }

    const handleStateChange = (e) => {
        setState(e.target.value)
    }

    const handleZipChange = (e) => {
        setZip(e.target.value)
    }

    const handleEmailChange = (e) => {
        setEmail(e.target.value)
    }

    const handleEmailConfirmChange = (e) => {
        setEmailConfirm(e.target.value)
    }

    const getSessions = async () => {
        const URL = `${HOSTNAME}/api/Lido/GetTBNarcanSessions`

        try {
            setSubmit()
            let response = await axios.get(URL)
            if (response.status !== 200) {
                console.error('Bad response getting sessions:', response.status)
                dialog('Couldn\'t get response')
                setSubmit(false)
                return -1
            }

            let data = response.data
            setSessions(data)
            setSubmit(false)
        } catch (error) {
            dialog('There was an error getting sessions.\nError:' + error.message)
            console.error('Error loading available sessions:', error.response)
            setSubmit(false)
            return -1
        }
    }

    const validateForm = () => {
        let
            regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        if (session === 0) {
            dialog('Please select a training session.')
            return 0
        }

        if (firstName === '') {
            dialog('Please provide a first name.')
            return 0
        }

        if (lastName === '') {
            dialog('Please provide a last name.')
            return 0
        }

        if (phone === '') {
            dialog('Please provide a phone number.')
            return 0
        } else if (phone.length !== 13) {
            dialog('Phone number invalid.')
            return 0
        }

        if (address === '') {
            dialog('Please provide an address.')
            return 0
        }

        if (city === '') {
            dialog('Please provide a city.')
            return 0
        }

        if (state === '') {
            dialog('Please select a state.')
            return 0
        }

        if (zip === '') {
            dialog('Please provide a zip code.')
            return 0
        }

        if (email === '') {
            dialog('Please provide an email address.')
            return 0
        } else if (!regexEmail.test(email)) {
            dialog('Email is not valid.')
            return 0
        }

        if (emailConfirm === '') {
            dialog('Please confirm your email address.')
            return 0
        } else if (email !== emailConfirm) {
            dialog('Emails must match.')
            return 0
        }

        return 1
    }

    const handleSubmit = async () => {
        if (!validateForm())
            return -1

        let
            json = {
                session: session,
                firstName: firstName,
                lastName: lastName,
                phone: phone,
                address: address,
                city: city,
                state: state,
                zip: zip,
                email: email
            },
            data = new FormData()
        data.append('json', JSON.stringify(json))

        const URL = `${HOSTNAME}/api/Lido/PostTBNarcanForm`

        try {
            setSubmit()
            let response = await axios.post(URL, data)
            if (response.status !== 200) {
                console.error('Bad response submitting form:', response.status)
                dialog('Couldn\'t get response')
                setSubmit(false)
                return -1
            }

            setSubmit(false)
            history.push('/Thanks')
        } catch (error) {
            dialog('There was an error submitting form.\nError:' + error.message)
            console.error('Error submitting form:', error.response)
            setSubmit(false)
            return -1
        }
    }

    useEffect(() => {
        getSessions()
    }, [])

    return (
        <>
            <AppBarTop />
            <Container>
                <Grid container spacing={1} mt={2} justify='center' alignItems='center' direction='row'>

                    <Grid item xs={12}>
                        <Paper elevation={0}>
                            <Box px={2} py={1}>
                                <Typography variant='h5' component='h1'>Narcan Training</Typography>
                                <Typography variant='h6' component='h2'>Session Dates</Typography>
                                <TableContainer>
                                    <Table size='small'>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Date</TableCell>
                                                <TableCell>Location</TableCell>
                                                <TableCell>Time</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {loading &&
                                                <>
                                                    <TableRow>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                        <TableCell><Skeleton /></TableCell>
                                                    </TableRow>
                                                </>
                                            }
                                            {
                                                !loading && sessions && sessions.map(session => {
                                                    let
                                                        datetime = dayjs(session.Date),
                                                        date = datetime.format('MMM D, YYYY'),
                                                        time = datetime.format('h:mm A')
                                                    return (
                                                        <TableRow key={session.Id}>
                                                            <TableCell>{date}</TableCell>
                                                            <TableCell>{session.Location}, {session.Address}</TableCell>
                                                            <TableCell>{time}</TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant='h6' component='h2'>Session Sign Up</Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl variant='outlined' fullWidth>
                            <InputLabel id='sessionLabel'>Session</InputLabel>
                            {loading && <Skeleton height={56} />}
                            {!loading &&
                                <>
                                    <Select
                                        labelId='sessionLabel'
                                        value={session}
                                        onChange={handleSessionChange}
                                        label='Session'
                                        autoFocus
                                    >
                                        <MenuItem value='0' disabled>Select a Session</MenuItem>
                                        {sessions && sessions.map(session => {
                                            let
                                                datetime = dayjs(session.Date),
                                                date = datetime.format('MMM D'),
                                                time = datetime.format('h:mm A')
                                            return <MenuItem key={session.Id} value={session.Id}>{date}, {session.Location}, {time}</MenuItem>
                                        })}
                                    </Select>
                                </>
                            }
                            <FormHelperText>*Only sessions with availability are shown</FormHelperText>
                        </FormControl>
                        <Typography variant='caption'></Typography>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant='outlined'
                            margin='normal'
                            required
                            fullWidth
                            id='firstName'
                            label='First Name'
                            name='firstName'
                            value={firstName}
                            onChange={handleFirstNameChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant='outlined'
                            margin='normal'
                            required
                            fullWidth
                            id='lastName'
                            label='Last Name'
                            name='lastName'
                            value={lastName}
                            onChange={handleLastNameChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <InputMask
                            mask='(999)999-9999'
                            value={phone}
                            maskChar=''
                            onChange={handlePhoneChange}
                        >
                            {() => (
                                <TextField
                                    variant='outlined'
                                    required
                                    fullWidth
                                    id='phone'
                                    label='Phone'
                                    name='phone'
                                    className={classes.fixTop}
                                    type='tel'
                                />
                            )}
                        </InputMask>
                    </Grid>

                    <Grid item xs={12} sm={12}>
                        <TextField
                            variant='outlined'
                            margin='normal'
                            fullWidth
                            required
                            id='address'
                            label='Address'
                            name='address'
                            value={address}
                            onChange={handleAddressChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <FormControl variant='outlined' fullWidth>
                            <TextField
                                variant='outlined'
                                margin='normal'
                                required
                                fullWidth
                                id='city'
                                label='City'
                                name='city'
                                value={city}
                                onChange={handleCityChange}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <FormControl variant='outlined' fullWidth className={classes.fixTop}>
                            <InputLabel id='stateLabel' required>State</InputLabel>
                            <Select
                                labelId='stateLabel'
                                value={state}
                                onChange={handleStateChange}
                                label='State'
                            >
                                <MenuItem value='AL'>Alabama - AL</MenuItem>
                                <MenuItem value='AK'>Alaska - AK</MenuItem>
                                <MenuItem value='AZ'>Arizona - AZ</MenuItem>
                                <MenuItem value='AR'>Arkansas - AR</MenuItem>
                                <MenuItem value='CA'>California - CA</MenuItem>
                                <MenuItem value='CO'>Colorado - CO</MenuItem>
                                <MenuItem value='CT'>Connecticut - CT</MenuItem>
                                <MenuItem value='DE'>Delaware - DE</MenuItem>
                                <MenuItem value='FL'>Florida - FL</MenuItem>
                                <MenuItem value='GA'>Georgia - GA</MenuItem>
                                <MenuItem value='HI'>Hawaii - HI</MenuItem>
                                <MenuItem value='ID'>Idaho - ID</MenuItem>
                                <MenuItem value='IL'>Illinois - IL</MenuItem>
                                <MenuItem value='IN'>Indiana - IN</MenuItem>
                                <MenuItem value='IA'>Iowa - IA</MenuItem>
                                <MenuItem value='KS'>Kansas - KS</MenuItem>
                                <MenuItem value='KY'>Kentucky - KY</MenuItem>
                                <MenuItem value='LA'>Louisiana - LA</MenuItem>
                                <MenuItem value='ME'>Maine - ME</MenuItem>
                                <MenuItem value='MD'>Maryland - MD</MenuItem>
                                <MenuItem value='MA'>Massachusetts - MA</MenuItem>
                                <MenuItem value='MI'>Michigan - MI</MenuItem>
                                <MenuItem value='MN'>Minnesota - MN</MenuItem>
                                <MenuItem value='MS'>Mississippi - MS</MenuItem>
                                <MenuItem value='MO'>Missouri - MO</MenuItem>
                                <MenuItem value='MT'>Montana - MT</MenuItem>
                                <MenuItem value='NE'>Nebraska - NE</MenuItem>
                                <MenuItem value='NV'>Nevada - NV</MenuItem>
                                <MenuItem value='NH'>New Hampshire - NH</MenuItem>
                                <MenuItem value='NJ'>New Jersey - NJ</MenuItem>
                                <MenuItem value='NM'>New Mexico - NM</MenuItem>
                                <MenuItem value='NY'>New York - NY</MenuItem>
                                <MenuItem value='NC'>North Carolina - NC</MenuItem>
                                <MenuItem value='ND'>North Dakota - ND</MenuItem>
                                <MenuItem value='OH'>Ohio - OH</MenuItem>
                                <MenuItem value='OK'>Oklahoma - OK</MenuItem>
                                <MenuItem value='OR'>Oregon - OR</MenuItem>
                                <MenuItem value='PA'>Pennsylvania - PA</MenuItem>
                                <MenuItem value='RI'>Rhode Island - RI</MenuItem>
                                <MenuItem value='SC'>South Carolina - SC</MenuItem>
                                <MenuItem value='SD'>South Dakota - SD</MenuItem>
                                <MenuItem value='TN'>Tennessee - TN</MenuItem>
                                <MenuItem value='TX'>Texas - TX</MenuItem>
                                <MenuItem value='UT'>Utah - UT</MenuItem>
                                <MenuItem value='VT'>Vermont - VT</MenuItem>
                                <MenuItem value='VA'>Virginia - VA</MenuItem>
                                <MenuItem value='WA'>Washington - WA</MenuItem>
                                <MenuItem value='WV'>West Virginia - WV</MenuItem>
                                <MenuItem value='WI'>Wisconsin - WI</MenuItem>
                                <MenuItem value='WY'>Wyoming - WY</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <TextField
                            variant='outlined'
                            margin='normal'
                            required
                            fullWidth
                            id='zip'
                            label='Zip'
                            name='zip'
                            value={zip}
                            onChange={handleZipChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant='outlined'
                            margin='normal'
                            required
                            fullWidth
                            id='email'
                            label='Email'
                            name='email'
                            value={email}
                            onChange={handleEmailChange}
                            type='email'
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            variant='outlined'
                            margin='normal'
                            required
                            fullWidth
                            id='emailConfirm'
                            label='Confirm Email'
                            name='emailConfirm'
                            value={emailConfirm}
                            onChange={handleEmailConfirmChange}
                            type='email'
                        />
                    </Grid>


                </Grid>

                <Grid container justifyContent='center' alignItems='center'>

                    <Grid item xs={12} my={1.5}>
                        <Divider />
                    </Grid>
                    <Grid item>
                        <Paper elevation={0}>
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={handleSubmit}
                                disabled={disableSubmit}
                            >{loading ? 'loading' : 'Submit'}</Button>
                        </Paper>
                    </Grid>

                </Grid>

                <Copyright />
            </Container>
            <AlertDialog
                dialogDisplay={dialogDisplay}
                setDialogDisplay={setDialogDisplay}
            >
                {dialogMessage}
            </AlertDialog>
        </>
    )
}

export default Main
